import { Link } from "react-router-dom";
import { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaCommentDots,
  FaChartLine,
  FaFunnelDollar,
  FaCashRegister,
  FaClock,
} from "react-icons/fa";
import { createContact } from "../services/contactService";
import Swal from "sweetalert2";
export function ContactPage() {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const showMessage = (msg = "", type = "success") => {
    const toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
    });
    toast.fire({ icon: type, title: msg });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await createContact(formData);
      console.log({ response });

      if (response?.data?.success) {
        showMessage("Message Sent successfully", "success");
        setFormData({ full_name: "", email: "", subject: "", message: "" });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response?.data?.message || "Something went wrong.",
          confirmButtonColor: "#43a047",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || "Server error.",
        confirmButtonColor: "#43a047",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white min-h-screen font-sans antialiased selection:bg-[#43a047] selection:text-white">
      {/* Breadcrumb */}
      <div className="w-full">
        <div
          className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
          style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
        >
          <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
            <h2 className="text-2xl text-black font-semibold mb-2">
              Contact Us
            </h2>
            <Link to="/" className="hover:text-[#43a047] transition-colors">
              Home
            </Link>
            <span className="mx-2 text-gray-300">/</span>
            <span className="text-gray-600">Contact Us</span>
          </nav>
        </div>
        <div className="bg-gray-50 border-b border-gray-100 py-4"></div>
      </div>

      {/* Map */}
      {/* Map */}
      <div className="w-full h-[320px] md:h-[420px] bg-gray-100 relative overflow-hidden border-b border-gray-200">
        <iframe
          title="Store Location Map"
          className="w-full h-full grayscale filter contrast-125 opacity-90"
          src="https://www.google.com/maps?q=Sattva+Square,+150+Feet+Ring+Rd,+opp.+Twinstar,+Rajkot,+Gujarat+360005&output=embed"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
          allowFullScreen
        />
        <div className="absolute top-0 left-0 right-0 h-4 bg-gradient-to-b from-black/5 to-transparent pointer-events-none" />
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 py-10 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Left Info */}
          <div className="lg:col-span-5 space-y-6">
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 tracking-wide mb-4">
                Contact Us
              </h2>
              <p className="text-gray-500 text-[14px] md:text-[14px] leading-relaxed mb-6">
                Get in touch with Shree Ambika Global. We would love to hear
                from you! Whether you have a question about our products, need
                sales support, or want to share feedback, our team is ready to
                assist you. Please fill out the form below or use our contact
                details to reach out with any inquiries or feedback. We strive
                to respond to all messages as quickly as possible.
              </p>
            </div>
            <div className="space-y-4 text-sm md:text-sm text-gray-700">
              <div className="flex items-start gap-3.5 group">
                <div className="mt-0.5 text-gray-400 group-hover:text-[#43a047] transition-colors">
                  <FaMapMarkerAlt size={16} />
                </div>
                <p className="leading-relaxed ">
                  <span className="font-semibold text-gray-900 block mb-0.5">
                    Address :
                  </span>
                  813, Sattva Square, 150 Feet Ring Rd,
                  <br /> opp. Twin Star,
                  <br />
                  Besides RK Supreme, Nana Mava, <br />
                  Rajkot, Gujarat 360005
                </p>
              </div>
              <div className="flex flex-col sm:flex-row sm:justify-between gap-4">
                <div className="flex  items-start gap-3.5 group">
                  <div className="mt-1 text-gray-400 group-hover:text-[#43a047] transition-colors">
                    <FaEnvelope size={15} />
                  </div>
                  <p className="leading-relaxed ">
                    <span className="font-semibold text-gray-900  text-[15px] block mb-0.5">
                      Email :
                    </span>
                    <a
                      href="mailto:contact@ambikaglobal.in"
                      className="hover:text-[#43a047] transition-colors text-[15px]"
                    >
                      contact@ambikaglobal.in
                    </a>
                  </p>
                </div>
                <div className="flex items-start gap-3.5 group">
                  <div className="mt-1 text-gray-400 group-hover:text-[#43a047] transition-colors">
                    <FaCashRegister size={15} />
                  </div>
                  <p className="leading-relaxed">
                    <span className="font-semibold text-gray-900 block mb-0.5">
                      Sales :
                    </span>
                    <a
                      href="mailto:sales@ambikaglobal.in"
                      className="hover:text-[#43a047] transition-colors text-[15px]"
                    >
                      sales@ambikaglobal.in
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row sm:justify-between gap-4 sm:me-10">
                <div className="flex items-start gap-3.5 group">
                  <div className="mt-1 text-gray-400 group-hover:text-[#43a047] transition-colors">
                    <FaCommentDots size={15} />
                  </div>
                  <p className="leading-relaxed">
                    <span className="font-semibold text-gray-900 block mb-0.5">
                      Feedback :
                    </span>
                    <a
                      href="mailto:feedback@ambikaglobal.in"
                      className="hover:text-[#43a047] transition-colors text-[15px]"
                    >
                      feedback@ambikaglobal.in
                    </a>
                  </p>
                </div>
                <div className="flex items-start gap-3.5 group">
                  <div className="mt-0.5 text-gray-400 group-hover:text-[#43a047] transition-colors">
                    <FaPhone size={15} />
                  </div>
                  <p className="leading-relaxed">
                    <span className="font-semibold text-gray-900 block mb-0.5">
                      Call us :
                    </span>
                    <a
                      href="tel:0823456789"
                      className="hover:text-[#43a047] transition-colors text-[15px] whitespace-nowrap"
                    >
                      +91 8999718146
                    </a>
                  </p>
                </div>
              </div>
              <div className="border-t border-gray-100 my-2 pt-2"></div>
                <div>
                  {/* Clean & Balanced Visit Us Section */}
                  <div className="flex items-start gap-3.5 group">
                    <div className="mt-1 text-gray-400 group-hover:text-[#43a047] transition-colors">
                      <FaClock size={15} />
                    </div>
                    <div className="leading-relaxed w-full">
                      <span className="font-semibold text-gray-900 block mb-1">
                        Visit Us / Open Hours :
                      </span>
                      <div className="space-y-1 text-gray-600 max-w-[260px]">
                        <div className="flex justify-between">
                          <span>Mon - Sat:</span>
                          <span className="text-gray-900 font-medium">
                            10:00 AM - 08:00 PM
                          </span>
                        </div>
                        <div className="flex justify-between text-red-500 font-medium">
                          <span>Sunday:</span>
                          <span>Closed</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>

          {/* Right Form */}
          <div className="lg:col-span-7 bg-white">
            {/* <h2 className="text-2xl font-semibold text-gray-900 tracking-wide mb-6">Tell Us Your Project</h2> */}

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wider">
                  Your Name (required)
                </label>
                <input
                  type="text"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  className="w-full bg-white border border-gray-200 px-4 py-2.5 text-xs focus:outline-none focus:border-[#43a047] focus:ring-1 focus:ring-[#43a047] transition-all text-gray-800 rounded-sm"
                  required
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wider">
                  Your Email (required)
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full bg-white border border-gray-200 px-4 py-2.5 text-xs focus:outline-none focus:border-[#43a047] focus:ring-1 focus:ring-[#43a047] transition-all text-gray-800 rounded-sm"
                  required
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wider">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full bg-white border border-gray-200 px-4 py-2.5 text-xs focus:outline-none focus:border-[#43a047] focus:ring-1 focus:ring-[#43a047] transition-all text-gray-800 rounded-sm"
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wider">
                  Your Message
                </label>
                <textarea
                  rows={5}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full bg-white border border-gray-200 px-4 py-3 text-xs focus:outline-none focus:border-[#43a047] focus:ring-1 focus:ring-[#43a047] transition-all text-gray-800 resize-none rounded-sm"
                />
              </div>

              <div className="pt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-[#222222] hover:bg-[#CAE4C9] hover:text-[#222222] text-white text-xs font-bold uppercase tracking-widest px-8 py-3.5 rounded-sm transition-colors duration-200 shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {loading ? "Sending..." : "Send"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export function FAQPage() {
  // Configured to match the exact titles and content flow strings seen inside image_9f7e62.png
  const faqs = [
    {
      id: 0,
      q: "Mauris congue euismod purus at semper. Morbi et vulputate massa?",
      a: "Donec mattis finibus elit ut tristique. Nullam tempus nunc eget arcu vulputate, eu porttitor tellus commodo. Aliquam erat volutpat. Aliquam consectetur lorem eu viverra lobortis. Morbi gravida, nisi id fringilla ultricies, elit lorem eleifend lorem",
    },
    {
      id: 1,
      q: "Donec mattis finibus elit ut tristique?",
      a: "Donec mattis finibus elit ut tristique. Nullam tempus nunc eget arcu vulputate, eu porttitor tellus commodo.",
    },
    {
      id: 2,
      q: "Aenean elit orci, efficitur quis nisl at, accumsan?",
      a: "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Proin vel ante a orci tempus eleifend.",
    },
    {
      id: 3,
      q: "Pellentesque habitant morbi tristique senectus et netus?",
      a: "Maecenas nunc lacus, condimentum non nibh vel, pretium eleifend metus. Nunc maximus quam augue.",
    },
    {
      id: 4,
      q: "Nam pellentesque aliquam metus?",
      a: "Our organic products follow verified processing regulations ensuring that everything reaches your home in premium condition.",
    },
    {
      id: 5,
      q: "Aenean elit orci, efficitur quis nisl at?",
      a: "We offer flexible multi-tier delivery slots intended to accommodate busy residential windows cleanly.",
    },
    {
      id: 6,
      q: "Morbi gravida, nisi id fringilla ultricies, elit lorem?",
      a: "If you are unsatisfied with your farm items, please reach out directly within our support system window.",
    },
    {
      id: 7,
      q: "Aenean elit orci, efficitur quis nisl at, accumsan?",
      a: "Our dynamic network of localized packaging partners verifies item weight and safety constraints reliably.",
    },
  ];

  // Open index set to 0 by default to match the top open element item view in the image layout
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="bg-white min-h-screen font-sans antialiased text-[#555555]">
      {/* Centralized Minimalist Breadcrumb Block */}
      <div className="w-full">
        <div
          className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
          style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
        >
          <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
            <h2 className="text-2xl text-black font-semibold mb-2">About Us</h2>
            <Link to="/" className="hover:text-[#43a047] transition-colors">
              Home
            </Link>
            <span className="mx-2 text-gray-300">/</span>
            <span className="text-gray-600">Frequently Questions</span>
          </nav>
        </div>
      </div>

      {/* Intro Heading Copy Stack Blocks matching image layout content parameters */}
      <div className="max-w-4xl mx-auto px-4 pb-10">
        <h2 className="text-sm font-bold text-gray-900 tracking-wide mb-3">
          Below are frequently asked questions, you may find the answer for
          yourself
        </h2>
        <p className="text-xs text-gray-400 leading-relaxed font-light">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id erat
          sagittis, faucibus metus malesuada, eleifend turpis. Mauris semper
          augue id nisl aliquet, a porta lectus mattis. Nulla at tortor augue.
          In eget enim diam. Donec gravida tortor sem, ac fermentum nibh rutrum
          sit amet. Nulla convallis mauris vitae congue consequat. Donec
          interdum nunc purus, vitae vulputate arcu fringilla quis. Vivamus
          iaculis euismod dui.
        </p>
      </div>

      {/* Clean Accordion System Grid Container */}
      <div className="max-w-4xl mx-auto px-4 pb-20">
        <div className="space-y-3.5">
          {faqs.map((faq) => {
            const isOpen = activeIndex === faq.id;
            return (
              <div
                key={faq.id}
                className="border border-gray-200/90 rounded-sm overflow-hidden bg-white"
              >
                {/* Header Action Button Tab */}
                <button
                  type="button"
                  onClick={() => setActiveIndex(isOpen ? null : faq.id)}
                  className="w-full flex justify-between items-center px-5 py-3.5 text-left bg-[#f2f4f6] hover:bg-gray-100/80 transition-colors duration-150 group"
                >
                  <span className="text-xs font-medium text-gray-700 tracking-wide group-hover:text-gray-900 transition-colors">
                    {faq.q}
                  </span>

                  {/* Thin minimalist arrow pointer chevron */}
                  <svg
                    className={`w-3.5 h-3.5 text-gray-400 transition-transform duration-200 ease-out ${isOpen ? "transform rotate-180 text-[#43a047]" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {/* Smooth Animated Collapsible Description Content */}
                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    isOpen
                      ? "max-h-60 opacity-100 border-t border-gray-200/60"
                      : "max-h-0 opacity-0 pointer-events-none"
                  }`}
                >
                  <p className="p-5 text-xs text-gray-400 leading-relaxed font-light bg-white">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
}

export function LoginPage() {
  return (
    <div className="bg-white min-h-screen font-sans antialiased">
      <div className="bg-gray-50 py-4 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <nav className="text-sm text-gray-500">
            <Link to="/" className="hover:text-[#43a047]">
              Home
            </Link>
            <span className="mx-2">/</span>
            <span className="text-gray-800 font-medium">Login</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-3xl mx-auto">
          <div className="border border-gray-200 p-8 rounded-sm bg-white shadow-xs">
            <h3 className="text-xl font-bold text-gray-800 mb-6">Login</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">
                  Username or Email *
                </label>
                <input
                  type="email"
                  className="w-full border border-gray-200 px-4 py-2.5 text-xs focus:outline-none focus:border-[#43a047]"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">
                  Password *
                </label>
                <input
                  type="password"
                  className="w-full border border-gray-200 px-4 py-2.5 text-xs focus:outline-none focus:border-[#43a047]"
                />
              </div>
              <div className="flex items-center justify-between">
                <label className="flex items-center gap-2 text-xs text-gray-500 cursor-pointer select-none">
                  <input type="checkbox" className="accent-[#43a047]" />
                  Remember me
                </label>
                <a href="#" className="text-xs text-[#43a047] hover:underline">
                  Lost your password?
                </a>
              </div>
              <button className="w-full text-center bg-[#43a047] text-white text-xs font-bold py-3 uppercase tracking-wider hover:bg-[#388e3c] transition-colors rounded-sm">
                Login
              </button>
            </div>
          </div>

          <div className="border border-gray-200 p-8 rounded-sm bg-white shadow-xs">
            <h3 className="text-xl font-bold text-gray-800 mb-6">Register</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">
                  Email Address *
                </label>
                <input
                  type="email"
                  className="w-full border border-gray-200 px-4 py-2.5 text-xs focus:outline-none focus:border-[#43a047]"
                />
              </div>
              <p className="text-[11px] text-gray-400 leading-relaxed">
                A password will be sent to your email address.
              </p>
              <p className="text-[11px] text-gray-400 leading-relaxed">
                Your personal data will be used to support your experience, to
                manage access to your account, and for other purposes described
                in our Privacy Policy.
              </p>
              <button className="w-full text-center bg-[#222222] text-white text-xs font-bold py-3 uppercase tracking-wider hover:bg-black transition-colors rounded-sm">
                Register
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4 bg-white">
      <h1 className="text-9xl font-black text-[#43a047] opacity-20 tracking-tighter mb-4">
        404
      </h1>
      <h2 className="text-2xl font-bold text-gray-800 mb-3">Page Not Found</h2>
      <p className="text-gray-400 text-sm mb-6 max-w-xs">
        The page you are looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        className="bg-[#43a047] text-white font-bold text-xs uppercase tracking-widest px-8 py-3 rounded-full hover:bg-[#388e3c] transition-colors"
      >
        Go Back Home
      </Link>
    </div>
  );
}

{
  /* Private Sub-Footer Component layout abstraction strictly mapping the branding specs */
}
function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 pt-16 pb-0">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Logo Brand Info block */}
          <div>
            <h3 className="text-3xl font-black tracking-tight text-gray-900 mb-4">
              Safira
            </h3>
            <p className="text-gray-400 text-xs leading-relaxed mb-6 max-w-xs font-light">
              We are a team of designers and developers that create high quality
              eCommerce, WordPress, Shopify.
            </p>
            <div className="text-xs space-y-2 text-gray-700 font-light">
              <p>
                <span className="font-semibold text-gray-900">Address:</span>{" "}
                4710-4890 Breckinridge USA
              </p>
              <p>
                <span className="font-semibold text-gray-900">Email:</span>{" "}
                demo@hasthemes.com
              </p>
              <p>
                <span className="font-semibold text-gray-900">Call us:</span>{" "}
                (08) 23 456 789
              </p>
            </div>
          </div>

          {/* Links grid 1 */}
          <div>
            <h4 className="text-xs font-bold text-gray-900 mb-4 uppercase tracking-wider">
              Information
            </h4>
            <ul className="space-y-2.5 text-xs text-gray-500 font-light">
              <li>
                <Link to="/about" className="hover:text-[#43a047]">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/delivery" className="hover:text-[#43a047]">
                  Delivery Information
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-[#43a047]">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-[#43a047]">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#43a047]">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/sitemap" className="hover:text-[#43a047]">
                  Site Map
                </Link>
              </li>
            </ul>
          </div>

          {/* Links grid 2 */}
          <div>
            <h4 className="text-xs font-bold text-gray-900 mb-4 uppercase tracking-wider">
              Extras
            </h4>
            <ul className="space-y-2.5 text-xs text-gray-500 font-light">
              <li>
                <Link to="/brands" className="hover:text-[#43a047]">
                  Brands
                </Link>
              </li>
              <li>
                <Link to="/gifts" className="hover:text-[#43a047]">
                  Gift Certificates
                </Link>
              </li>
              <li>
                <Link to="/affiliate" className="hover:text-[#43a047]">
                  Affiliate
                </Link>
              </li>
              <li>
                <Link to="/specials" className="hover:text-[#43a047]">
                  Specials
                </Link>
              </li>
              <li>
                <Link to="/returns" className="hover:text-[#43a047]">
                  Returns
                </Link>
              </li>
              <li>
                <Link to="/orders" className="hover:text-[#43a047]">
                  Order History
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter subscription form widget container */}
          <div>
            <h4 className="text-xs font-bold text-gray-900 mb-4 uppercase tracking-wider">
              Sign Up Newsletter
            </h4>
            <p className="text-gray-400 text-xs mb-4 leading-relaxed font-light">
              Get updates by subscribe our weekly newsletter
            </p>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex items-center border border-gray-200 rounded-full overflow-hidden max-w-sm bg-white"
            >
              <input
                type="email"
                placeholder="Enter you email"
                className="w-full px-4 py-2 text-xs focus:outline-none text-gray-700 bg-transparent"
              />
              <button
                type="submit"
                className="bg-[#43a047] hover:bg-[#388e3c] text-white text-xs font-bold px-5 py-2.5 tracking-wider transition-colors uppercase whitespace-nowrap rounded-r-full"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Solid horizontal bottom brand bar element signature */}
      <div className="bg-[#43a047] h-1.5 w-full mt-8" />
    </footer>
  );
}
